<script setup lang="ts">
/* ============================================================
   OutlinePanel — the document's heading structure as a jump list

   A small popover (anchored bottom-left, opening upward) that lists
   every heading in the active doc, indented by level. Click a heading
   to scroll to it; the panel stays open so you can keep jumping around.
   Items come from DocView.getOutline(); jumps go back via DocView
   .scrollToHeading(index).
   ============================================================ */

defineProps<{ items: { level: number; text: string }[] }>()
const emit = defineEmits<{ (e: 'jump', index: number): void; (e: 'close'): void }>()
</script>

<template>
  <div class="outline-panel" role="dialog" aria-label="Document outline">
    <header class="outline-head">
      <span class="outline-title">Outline</span>
      <button class="outline-close" aria-label="Close outline" @click="emit('close')">×</button>
    </header>
    <div v-if="items.length === 0" class="outline-empty">No headings in this document.</div>
    <ul v-else class="outline-list">
      <li v-for="(item, i) in items" :key="i">
        <button
          class="outline-item"
          :class="`is-l${item.level}`"
          :style="{ paddingLeft: 12 + (item.level - 1) * 14 + 'px' }"
          :title="item.text"
          @click="emit('jump', i)"
        >
          {{ item.text }}
        </button>
      </li>
    </ul>
  </div>
</template>
